import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import {
  getRouteTransitionKey,
  resolveRouteVariant,
} from "./resolveRouteVariant";

/**
 * Returns the Section 8 motion variant for the current route transition.
 * `from` is the previous pathname (still in the ref on the first render after navigation).
 */
export function useRouteVariant() {
  const { pathname } = useLocation();
  const prevPathRef = useRef(pathname);
  const variant = resolveRouteVariant(prevPathRef.current, pathname);

  useEffect(() => {
    prevPathRef.current = pathname;
  }, [pathname]);

  return {
    variant,
    transitionKey: getRouteTransitionKey(pathname),
  };
}
